const CooperativeEnterpriseComponent = () => import('@/views/business/CooperativeEnterprise/CooperativeEnterpriseView')

export default [
    {
        path:'/CooperativeEnterpriseIndex',
        name:'CooperativeEnterpriseComponent',
        component:CooperativeEnterpriseComponent
    }
]